"use client";

import { c as _c } from "react/compiler-runtime";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiRepCategoriesPage } from "@/generated/models/ApiRepCategoriesPage";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import { commonApiFetch } from "@/services/api/common-api";
import { RateMatter } from "@/types/enums";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";
import { useState } from "react";
import UserPageIdentityHeader from "../identity/header/UserPageIdentityHeader";
import UserPageIdentityHeaderCICRate from "../identity/header/cic-rate/UserPageIdentityHeaderCICRate";
import UserPageIdentityStatements from "../identity/statements/UserPageIdentityStatements";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
import UserPageCombinedActivityLog from "./UserPageCombinedActivityLog";
import type { RepDirection } from "./UserPageRep.helpers";
import UserPageRepHeader from "./header/UserPageRepHeader";
import UserPageRepMobile from "./UserPageRepMobile";
export default function UserPageRep(t0) {
  const $ = _c(85);
  const {
    profile,
    initialActivityLogParams
  } = t0;
  const params = useParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const user = t1;
  const [repDirection, setRepDirection] = useState("received");
  let t2;
  let t3;
  if ($[2] !== user) {
    t2 = [QueryKey.REP_OVERVIEW, {
      handleOrWallet: user,
      direction: "incoming"
    }];
    t3 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/rep/overview`
    });
    $[2] = user;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = !!user;
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: repOverview,
    isFetching: isFetchingOverview
  } = useQuery(t5);
  let t6;
  let t7;
  if ($[9] !== user) {
    t6 = [QueryKey.REP_CATEGORIES, {
      handleOrWallet: user,
      direction: "incoming"
    }];
    t7 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/rep/categories`,
      params: {
        page: "1",
        page_size: "20",
        top_contributors_limit: "5"
      }
    });
    $[9] = user;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  const t8 = !!user;
  let t9;
  if ($[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = {
      queryKey: t6,
      queryFn: t7,
      enabled: t8
    };
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const {
    data: repCategories,
    isFetching: isFetchingCategories
  } = useQuery(t9);
  let t10;
  let t11;
  if ($[16] !== user) {
    t10 = [QueryKey.REP_OVERVIEW, {
      handleOrWallet: user,
      direction: "outgoing"
    }];
    t11 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/rep/overview`,
      params: {
        direction: "outgoing"
      }
    });
    $[16] = user;
    $[17] = t10;
    $[18] = t11;
  } else {
    t10 = $[17];
    t11 = $[18];
  }
  const t12 = !!user && repDirection === "given";
  let t13;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
    t13 = {
      queryKey: t10,
      queryFn: t11,
      enabled: t12
    };
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const {
    data: repOverviewGiven,
    isFetching: isFetchingOverviewGiven
  } = useQuery(t13);
  let t14;
  let t15;
  if ($[23] !== user) {
    t14 = [QueryKey.REP_CATEGORIES, {
      handleOrWallet: user,
      direction: "outgoing"
    }];
    t15 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/rep/categories`,
      params: {
        direction: "outgoing",
        page: "1",
        page_size: "20",
        top_contributors_limit: "5"
      }
    });
    $[23] = user;
    $[24] = t14;
    $[25] = t15;
  } else {
    t14 = $[24];
    t15 = $[25];
  }
  const t16 = !!user && repDirection === "given";
  let t17;
  if ($[26] !== t14 || $[27] !== t15 || $[28] !== t16) {
    t17 = {
      queryKey: t14,
      queryFn: t15,
      enabled: t16
    };
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const {
    data: repCategoriesGiven,
    isFetching: isFetchingCategoriesGiven
  } = useQuery(t17);
  let t18;
  let t19;
  if ($[30] !== user) {
    t18 = [QueryKey.CIC_OVERVIEW, {
      handleOrWallet: user
    }];
    t19 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/cic/overview`
    });
    $[30] = user;
    $[31] = t18;
    $[32] = t19;
  } else {
    t18 = $[31];
    t19 = $[32];
  }
  const t20 = !!user;
  let t21;
  if ($[33] !== t18 || $[34] !== t19 || $[35] !== t20) {
    t21 = {
      queryKey: t18,
      queryFn: t19,
      enabled: t20
    };
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  const {
    data: cicOverview
  } = useQuery(t21);
  const activeOverview = repDirection === "received" ? repOverview ?? null : repOverviewGiven ?? null;
  let t22;
  if ($[37] !== repCategories?.data || $[38] !== repCategoriesGiven?.data || $[39] !== repDirection) {
    t22 = repDirection === "received" ? repCategories?.data ?? [] : repCategoriesGiven?.data ?? [];
    $[37] = repCategories?.data;
    $[38] = repCategoriesGiven?.data;
    $[39] = repDirection;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  const activeCategories = t22;
  const activeLoading = repDirection === "received" ? isFetchingOverview || isFetchingCategories : isFetchingOverviewGiven || isFetchingCategoriesGiven;
  const t23 = cicOverview ?? null;
  let t24;
  if ($[41] !== activeCategories || $[42] !== activeLoading || $[43] !== activeOverview || $[44] !== initialActivityLogParams || $[45] !== profile || $[46] !== repDirection || $[47] !== t23) {
    t24 = <div className="lg:tw-hidden"><UserPageRepMobile profile={profile} overview={activeOverview} categories={activeCategories} cicOverview={t23} repDirection={repDirection} onRepDirectionChange={setRepDirection} initialActivityLogParams={initialActivityLogParams} loading={activeLoading} /></div>;
    $[41] = activeCategories;
    $[42] = activeLoading;
    $[43] = activeOverview;
    $[44] = initialActivityLogParams;
    $[45] = profile;
    $[46] = repDirection;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== activeCategories || $[50] !== activeLoading || $[51] !== activeOverview || $[52] !== profile || $[53] !== repDirection) {
    t25 = <UserPageRepHeader overview={activeOverview} categories={activeCategories} profile={profile} repDirection={repDirection} onRepDirectionChange={setRepDirection} loading={activeLoading} />;
    $[49] = activeCategories;
    $[50] = activeLoading;
    $[51] = activeOverview;
    $[52] = profile;
    $[53] = repDirection;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== initialActivityLogParams) {
    t26 = <div className="tw-mt-6 lg:tw-mt-8"><UserPageCombinedActivityLog initialActivityLogParams={initialActivityLogParams} /></div>;
    $[55] = initialActivityLogParams;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t25 || $[58] !== t26) {
    t27 = <div className="tw-min-w-0">{t25}{t26}</div>;
    $[57] = t25;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  let t29;
  let t30;
  let t31;
  let t32;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-emerald-500/[0.05] tw-via-transparent tw-to-transparent" />;
    t29 = <div className="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-emerald-400/25 tw-to-transparent" />;
    t30 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-emerald-400/40 tw-to-transparent" />;
    t31 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-emerald-400/20 tw-to-transparent" />;
    t32 = <div className="tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-emerald-400/20 tw-to-transparent" />;
    $[60] = t28;
    $[61] = t29;
    $[62] = t30;
    $[63] = t31;
    $[64] = t32;
  } else {
    t28 = $[60];
    t29 = $[61];
    t30 = $[62];
    t31 = $[63];
    t32 = $[64];
  }
  const t33 = cicOverview ?? null;
  let t34;
  if ($[65] !== profile || $[66] !== t33) {
    t34 = <UserPageIdentityHeader profile={profile} cicOverview={t33} />;
    $[65] = profile;
    $[66] = t33;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== profile) {
    t35 = <UserPageIdentityStatements profile={profile} />;
    $[68] = profile;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== profile) {
    t36 = <UserPageIdentityHeaderCICRate profile={profile} isTooltip={false} />;
    $[70] = profile;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  let t37;
  if ($[72] !== profile || $[73] !== t36) {
    t37 = <div className="tw-px-6 tw-pb-8"><UserPageRateWrapper profile={profile} type={RateMatter.NIC} hideOwnProfileMessage={true}>{t36}</UserPageRateWrapper></div>;
    $[72] = profile;
    $[73] = t36;
    $[74] = t37;
  } else {
    t37 = $[74];
  }
  let t38;
  if ($[75] !== t34 || $[76] !== t35 || $[77] !== t37) {
    t38 = <div className="tw-min-w-0 tw-self-start"><div className="tw-relative tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-white/[0.08] tw-bg-[#08090b]">{t28}{t29}{t30}{t31}{t32}<div className="tw-relative tw-z-10">{t34}{t35}{t37}</div></div></div>;
    $[75] = t34;
    $[76] = t35;
    $[77] = t37;
    $[78] = t38;
  } else {
    t38 = $[78];
  }
  let t39;
  if ($[79] !== t27 || $[80] !== t38) {
    t39 = <div className="tw-hidden lg:tw-block"><div className="tw-grid tw-grid-cols-1 tw-gap-x-8 lg:tw-grid-cols-[minmax(0,2fr)_minmax(22rem,1fr)] xl:tw-gap-x-10">{t27}{t38}</div></div>;
    $[79] = t27;
    $[80] = t38;
    $[81] = t39;
  } else {
    t39 = $[81];
  }
  let t40;
  if ($[82] !== t24 || $[83] !== t39) {
    t40 = <div className="tailwind-scope">{t24}{t39}</div>;
    $[82] = t24;
    $[83] = t39;
    $[84] = t40;
  } else {
    t40 = $[84];
  }
  return t40;
}